import { put, call, select } from 'redux-saga/effects'
import I from 'immutable'
import Api from 'domain/api'
import * as Actions from './actions'
import * as M from 'domain/env'
import { pageIsLoading, skeleton } from 'domain/loading'
import { Sort } from 'types/common'

interface Params {
  page?: number
  perPage?: number
  order?: Sort
  order_by?: string | null
  status?: string
  search?: string
}

export function* ensureGetParsedResumes(props?: { payload?: Params; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  if (!props || !props.payload || props.payload.page === 1) {
    yield put({ type: skeleton, payload: true })
    yield put({ type: pageIsLoading, payload: true })
  }
  const params = (props && props.payload) || { status: 'uploaded' }
  try {
    const { data } = yield call(Api.getParsedResumes, {
      headers: { Authorization: `Bearer ${headers}` },
      params
    })
    yield put({ type: Actions.newParsedResumesList.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({
      type: Actions.parsedResumesList.failure,
      err
    })
  } finally {
    yield put({ type: skeleton, payload: false })
    yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensureForceAddToQueue(props: { payload: number; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  // yield put({ type: pageIsLoading, payload: true })
  const id = props && props.payload
  try {
    const {
      data: { data }
    } = yield call(Api.addParsedResumeToQueue, {
      headers: { Authorization: `Bearer ${headers}` },
      data: { ids: [id] }
    })
    yield put({
      type: Actions.forceAddResumeToQueue.success,
      payload: I.fromJS(data)
    })
  } catch (err) {
    yield put({
      type: Actions.forceAddResumeToQueue.failure,
      err
    })
  } finally {
    // yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensureRemoveFromQueue(props: { payload: number; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  // yield put({ type: pageIsLoading, payload: true })
  const id = props && props.payload
  try {
    const {
      data: { data }
    } = yield call(Api.removeParsedResumeFromQueue, {
      headers: { Authorization: `Bearer ${headers}` },
      data: { ids: [id] }
    })
    yield put({
      type: Actions.removeResumeFromQueue.success,
      payload: I.fromJS(data)
    })
  } catch (err) {
    yield put({
      type: Actions.removeResumeFromQueue.failure,
      err
    })
  } finally {
    // yield put({ type: pageIsLoading, payload: false })
  }
}
